import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { getGiftCardTemplatesApi, getTimezoneConfigApi } from 'api';
import { useDispatch, useSelector } from 'react-redux';
import { BackdropCircular, Breadcrumb } from 'components';
import { useStyles } from '../styles';
import GiftCodeInfoForm from './GiftCodeForm';


const CreateGiftCode = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const {isCreateGiftCodeLoading, isGiftCodeTemplatesLoading, isGiftCodesListLoading} = useSelector((state: IReduxState) => state.gift_card);

  useEffect(() => {
    getGiftCardTemplatesApi({dispatch});
    getTimezoneConfigApi({dispatch});
  }, []);

  const locationState = history.location.state as LocationState;
  const breadcrumbPath = locationState && locationState.params ? `/gift-cards${locationState.params}` : '/gift-cards';

  return (
    <div className="flex-grow flex-column relative h-full scroll-y pb-5">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Gift Cards', path: '/gift-cards'},
            { name: 'Create New Gift Code'}
          ]}
        />
      </div>
      <div className={`${classes.card} px-5`}>
        <GiftCodeInfoForm breadcrumbPath={breadcrumbPath} />
      </div>
      <BackdropCircular loading={isCreateGiftCodeLoading || isGiftCodeTemplatesLoading || isGiftCodesListLoading} />
    </div>
  );
};

export default CreateGiftCode;
